import { useEffect } from 'react';

/**
 * IosRedirectPage - Redireciona para a App Store (iOS)
 * Equivalente a: redirect/ios_app.html.erb
 */
export default function IosRedirectPage() {
  useEffect(() => {
    window.location.href = 'https://apps.apple.com/br/app/laager-meu-consumo/id1234387091';
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full w-8 h-8 border-[3px] border-[#007bff] border-t-transparent mb-4 mx-auto" role="status">
          <span className="sr-only">Redirecionando...</span>
        </div>
        <p>Redirecionando para a App Store...</p>
      </div>
    </div>
  );
}
